import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const PatientElectronicFolderPage = () => {
  const columns = [
    { key: 'folderName', label: 'Folder Name' },
    { key: 'description', label: 'Description' },
    { key: 'documentCount', label: 'Document Count' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'folderName', label: 'Folder Name', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', folderName: 'Admission Documents', description: 'Consent forms, face sheet, initial orders', documentCount: '156', active: 'Yes' },
    { id: '2', folderName: 'OASIS Assessments', description: 'OASIS-E assessments (SOC, ROC, Recert, DC)', documentCount: '432', active: 'Yes' },
    { id: '3', folderName: 'Physician Orders', description: 'Plan of care, medication orders, verbal orders', documentCount: '287', active: 'Yes' },
    { id: '4', folderName: 'Visit Notes', description: 'Skilled nursing, therapy, and aide visit notes', documentCount: '1245', active: 'Yes' },
    { id: '5', folderName: 'Lab Results', description: 'Laboratory test results', documentCount: '178', active: 'Yes' },
    { id: '6', folderName: 'Communication Log', description: 'Phone calls, coordination notes', documentCount: '523', active: 'Yes' },
    { id: '7', folderName: 'Insurance Documents', description: 'Authorization, eligibility, claims', documentCount: '89', active: 'Yes' },
    { id: '8', folderName: 'Discharge Documents', description: 'Discharge summary, transfer forms', documentCount: '67', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Patient Electronic Document Folder"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Folder"
      formFields={formFields}
      apiEndpoint="/setup/patient-electronic-folder"
    />
  );
};

export default PatientElectronicFolderPage;
